import firebase, { db } from 'lib/firebase';
import omit from 'lodash/omit';

export const remove = async (id, key, userKey) => {
  try {
    const userId = firebase.auth().currentUser.uid;
    return db.update({
      [`users/${userId}/${userKey}/${id}`]: null,
      [`data/${key}/${id}`]: null,
    });
  } catch (e) {
    console.error(e);
  }
};

export const upsert = async (obj, key, userKey) => {
  try {
    const userId = firebase.auth().currentUser.uid;
    const objSave = omit(obj, ['id']);

    let update = {};

    // Update Existing
    if (obj.id) {
      update = {
        [`users/${userId}/${userKey}/${obj.id}`]: objSave,
        [`data/${key}/${obj.id}`]: objSave,
      };

      // Create New
    } else {
      const settingKey = db.child(`data/${key}`).push().key;
      update = {
        [`users/${userId}/${userKey}/${settingKey}`]: objSave,
        [`data/${key}/${settingKey}`]: objSave,
      };
    }

    return db.update(update);
  } catch (e) {
    console.error(e);
  }
};



// WEBPACK FOOTER //
// ./src/lib/firebase-write.js